<template>
  <div :class="['bottom-switch','lives-type',centerStyle?centerStyle:'']"
       :style="{padding:(centerStyle=='flowArchShow'?'18px 20px':'')}">
    <div class="bottom-content swiper-container"
         :style="{height:`${baseHeight}px`}"
         :class="['bottom-content'+ swiperInd]">
      <ul class="clearfix swiper-wrapper">
        <template v-for="(items,ind) in tagsDataList">
          <li class="fl swiper-slide"
              v-for="(item,inds) in items.standList"
              :key="'ll'+ind+'-'+inds"
              @click="handleOpenLink(item)"
              @contextmenu.stop.prevent="items.standAllName?$emit('emitContextMenuItem',ind,$event):''"
              @touchstart="touchstarts(ind)"
              @touchmove="touchmoves()"
              @touchend="touchends()">
            <a href="javascript:;"
               v-if="item.type=='lives'"
               @click.stop="$emit('emitHandleDetail',items,ind)">
              <ZImage :slotIcon="item.data?false:true"
                      :value="item.data?item.data:''"
                      :error-src="tagsAllEmpty?require('../../assets/image/images/livesMain/default_live_online_icon.png'):require('../../assets/image/images/default_media.png')" />
              <div class="li_hover">
                <p class="li_hover_title">
                  {{items.standAllName?items.standAllName:''}}
                </p>
                <!-- <div class="img_right"></div> -->
                <div class="li_hover_conter">
                  <div class="label-box"
                       v-if="items.standAllTag.length">
                    <div v-show="tag.name != '产品标识'"
                         class="label-set"
                         v-for="(tag,tin) in items.standAllTag"
                         :key="tin">
                      <span>{{tag.name?tag.name+'：':''}}</span>{{allPrice(tag.standardEnName) ? formatPrice(tag.data) : tag.data}}
                    </div>
                  </div>
                  <div v-else
                       class="no-data white"></div>
                </div>
              </div>
            </a>
            <a href="javascript:;"
               v-if="item.type=='videos'"
               @click.stop="$emit('emitHandleDetail',items,ind)">
              <ZImage :slotIcon="item.data?false:true"
                      :value="item.data?item.data:''"
                      :error-src="tagsAllEmpty?require('../../assets/image/images/livesMain/default_short_video_icon.png'):require('../../assets/image/images/default_media.png')" />
              <div class="li_hover">
                <p class="li_hover_title">
                  {{items.standAllName?items.standAllName:''}}
                </p>
                <!-- <div class="img_right"></div> -->
                <div class="li_hover_conter">
                  <div class="label-box"
                       v-if="items.standAllTag.length">
                    <div v-show="tag.name != '产品标识'"
                         class="label-set"
                         v-for="(tag,tin) in items.standAllTag"
                         :key="tin">
                      <span>{{tag.name?tag.name+'：':''}}</span>{{allPrice(tag.standardEnName) ? formatPrice(tag.data) : tag.data}}
                    </div>
                  </div>
                  <div v-else
                       class="no-data white"></div>
                </div>
              </div>
            </a>
            <a href="javascript:;"
               v-if="item.type=='images'"
               @click.stop="$emit('emitHandleDetail',items,ind)">
              <ZImage :value="item.data?item.data:''"
                      :slotIcon="true"
                      :error-src="tagsAllEmpty?require('../../assets/image/images/livesMain/default_hundred_impression_icon.png'):require('../../assets/image/images/default_media.png')" />
              <div class="li_hover">
                <p class="li_hover_title">
                  {{items.standAllName?items.standAllName:''}}
                </p>
                <!-- <div class="img_right"></div> -->
                <div class="li_hover_conter">
                  <div class="label-box"
                       v-if="items.standAllTag.length">
                    <div v-show="tag.name != '产品标识'"
                         class="label-set"
                         v-for="(tag,tin) in items.standAllTag"
                         :key="tin">
                      <span>{{tag.name?tag.name+'：':''}}</span>{{allPrice(tag.standardEnName) ? formatPrice(tag.data) : tag.data}}
                    </div>
                  </div>
                  <div v-else
                       class="no-data white"></div>
                </div>
              </div>
            </a>
            <a href="javascript:;"
               v-if="item.type=='articles'"
               @click.stop="$emit('emitHandleDetail',items,ind)">
              <ZImage :value="item.data?item.data:''"
                      :slotIcon="true"
                      :error-src="tagsAllEmpty?require('../../assets/image/images/livesMain/default_today_news_icon.png'):require('../../assets/image/images/default_media.png')" />
              <div class="li_hover">
                <p class="li_hover_title">
                  {{items.standAllName?items.standAllName:''}}
                </p>
                <!-- <div class="img_right"></div> -->
                <div class="li_hover_conter">
                  <div class="label-box"
                       v-if="items.standAllTag.length">
                    <div v-show="tag.name != '产品标识'"
                         class="label-set"
                         v-for="(tag,tin) in items.standAllTag"
                         :key="tin">
                      <span>{{tag.name?tag.name+'：':''}}</span>{{allPrice(tag.standardEnName) ? formatPrice(tag.data) : tag.data}}
                    </div>
                  </div>
                  <div v-else
                       class="no-data white"></div>
                </div>
              </div>
            </a>
            <a href="javascript:;"
               v-if="item.type=='files'"
               @click.stop="$emit('emitHandleDetail',items,ind)">
              <ZImage :value="item.data?item.data:''"
                      :slotIcon="true"
                      :error-src="tagsAllEmpty?require('../../assets/image/images/livesMain/default_baijia_library_icon.png'):require('../../assets/image/images/default_media.png')" />
              <div class="li_hover">
                <p class="li_hover_title">
                  {{items.standAllName?items.standAllName:''}}
                </p>
                <!-- <div class="img_right"></div> -->
                <div class="li_hover_conter">
                  <div class="label-box"
                       v-if="items.standAllTag.length">
                    <div v-show="tag.name != '产品标识'"
                         class="label-set"
                         v-for="(tag,tin) in items.standAllTag"
                         :key="tin">
                      <span>{{tag.name?tag.name+'：':''}}</span>{{allPrice(tag.standardEnName) ? formatPrice(tag.data) : tag.data}}
                    </div>
                  </div>
                  <div v-else
                       class="no-data white"></div>
                </div>
              </div>
            </a>
            <a href="javascript:;"
               v-if="item.type=='cmsknows'"
               @click.stop="$emit('emitHandleDetail',items,ind)">
              <ZImage :value="item.data?item.data:''"
                      :slotIcon="true"
                      :error-src="tagsAllEmpty?require('../../assets/image/images/livesMain/default_cm_knows_icon.png'):require('../../assets/image/images/default_media.png')" />
              <div class="li_hover">
                <p class="li_hover_title">
                  {{items.standAllName?items.standAllName:''}}
                </p>
                <!-- <div class="img_right"></div> -->
                <div class="li_hover_conter">
                  <div class="label-box"
                       v-if="items.standAllTag.length">
                    <div v-show="tag.name != '产品标识'"
                         class="label-set"
                         v-for="(tag,tin) in items.standAllTag"
                         :key="tin">
                      <span>{{tag.name?tag.name+'：':''}}</span>{{allPrice(tag.standardEnName) ? formatPrice(tag.data) : tag.data}}
                    </div>
                  </div>
                  <div v-else
                       class="no-data white"></div>
                </div>
              </div>
            </a>
            <a href="javascript:;"
               v-if="item.type=='opetrains'"
               @click.stop="$emit('emitHandleDetail',items,ind)">
              <ZImage :value="item.data?item.data:''"
                      :slotIcon="true"
                      :error-src="tagsAllEmpty?require('../../assets/image/images/livesMain/default_operation_training_icon.png'):require('../../assets/image/images/default_media.png')" />
              <div class="li_hover">
                <p class="li_hover_title">
                  {{items.standAllName?items.standAllName:''}}
                </p>
                <!-- <div class="img_right"></div> -->
                <div class="li_hover_conter">
                  <div class="label-box"
                       v-if="items.standAllTag.length">
                    <div v-show="tag.name != '产品标识'"
                         class="label-set"
                         v-for="(tag,tin) in items.standAllTag"
                         :key="tin">
                      <span>{{tag.name?tag.name+'：':''}}</span>{{allPrice(tag.standardEnName) ? formatPrice(tag.data) : tag.data}}
                    </div>
                  </div>
                  <div v-else
                       class="no-data white"></div>
                </div>
              </div>
            </a>
            <a href="javascript:;"
               v-if="item.type=='aidevices'"
               @click.stop="$emit('emitHandleDetail',items,ind)">
              <ZImage :value="item.data?item.data:''"
                      :slotIcon="true"
                      :error-src="tagsAllEmpty?require('../../assets/image/images/livesMain/default_ai_equipment_icon.png'):require('../../assets/image/images/default_media.png')" />
              <div class="li_hover">
                <p class="li_hover_title">
                  {{items.standAllName?items.standAllName:''}}
                </p>
                <!-- <div class="img_right"></div> -->
                <div class="li_hover_conter">
                  <div class="label-box"
                       v-if="items.standAllTag.length">
                    <div v-show="tag.name != '产品标识'"
                         class="label-set"
                         v-for="(tag,tin) in items.standAllTag"
                         :key="tin">
                      <span>{{tag.name?tag.name+'：':''}}</span>{{allPrice(tag.standardEnName) ? formatPrice(tag.data) : tag.data}}
                    </div>
                  </div>
                  <div v-else
                       class="no-data white"></div>
                </div>
              </div>
            </a>
            <a href="javascript:;"
               v-if="item.type=='texts'"
               @click.stop="$emit('emitHandleDetail',items,ind)">
              <ZImage :value="item.data?item.data:''"
                      :slotIcon="true"
                      :error-src="require('../../assets/image/images/default_media.png')" />
              <div class="li_hover">
                <p class="li_hover_title">
                  {{items.standAllName?items.standAllName:''}}
                </p>
                <!-- <div class="img_right"></div> -->
                <div class="li_hover_conter">
                  <div class="label-box"
                       v-if="items.standAllTag.length">
                    <div v-show="tag.name != '产品标识'"
                         class="label-set"
                         v-for="(tag,tin) in items.standAllTag"
                         :key="tin">
                      <span>{{tag.name?tag.name+'：':''}}</span>{{allPrice(tag.standardEnName) ? formatPrice(tag.data) : tag.data}}
                    </div>
                  </div>
                  <div v-else
                       class="no-data white"></div>
                </div>
              </div>
            </a>
          </li>
        </template>
      </ul>
      <div :class="['arrow-left','arrow-left'+ swiperInd]"></div>
      <div :class="['arrow-right','arrow-right'+ swiperInd]"></div>
    </div>
  </div>
</template>
<script>
import ZImage from "../ZImage.vue"
export default {
  name: 'baseGroup',
  components: {
    ZImage
  },
  props: {
    baseHeight: {
      type: Number
    },
    standList: {
      type: Array
    },
    swiperInd: {
      type: String
    },
    preNum: {
      type: Number
    },
    centerStyle: {
      type: String
    }
  },
  data () {
    return {
      timeOutEvent: 0,
      tagsDataList: [],
      tagsAllEmpty: true,
      tagsAlowList: [],
      mySwiper1: undefined,
      num: 0
    }
  },
  watch: {
    standList: function (val) {
      this.initGroupByType(val)
    }
  },
  mounted () {
    this.initGroupByType(this.standList);
    this.swiperFn();
  },
  methods: {
    touchstarts (ind) {
      var _this = this;
      // 长按事件触发
      clearTimeout(_this.timeOutEvent);
      _this.timeOutEvent = setTimeout(function () {
        _this.timeOutEvent = 0;
        _this.$emit('emitContextMenuItem', ind);
      }, 400);
      //长按400毫秒
      // e.preventDefault();
    },
    touchmove: function () {
      clearTimeout(this.timeOutEvent);
      this.timeOutEvent = 0;
    },
    touchend: function (e) {
      clearTimeout(this.timeOutEvent);
      return false;
    },
    handleOpenLink (item) {
      // const type = item.type;
      // var url = '';
      // switch(type){
      //     case 'lives':
      //         url = 'https://520emv.com/uoqid/?appId=tpzbzsptgyy'
      //         break;
      //     case 'videos':
      //         url='https://520emv.com/uoqid/?appId=dbsjzsptgyy'
      //         break;
      //     case 'images':
      //         url='https://520emv.com/uoqid/?appId=bjyxzsptgyy'
      //         break;
      //     case 'articles':
      //         url='https://520emv.com/uoqid/?appId=jrzxzsptgyy'
      //         break;
      //     case 'files':
      //         url='https://520emv.com/uoqid/?appId=bjwkzsptgyy'
      //         break;
      //     case 'cmsknows':
      //         url='https://520emv.com/uoqid/?appId=zjzdzsptgyy'
      //         break;
      //     case 'opetrains':
      //         url='https://520emv.com/uoqid/?appId=czpxzsptgyy'
      //         break;
      //     case 'aidevices':
      //         url='https://520emv.com/uoqid/?appId=aisbzsptgyy'
      //         break;
      //     default:
      //         url=''
      //         break;
      // }
      // if(url){
      //     this.open(url,'_self');
      // }
    },
    getMapNameByType (fileType) {
      var type = fileType;
      switch (type) {
        case '11':
          type = 'lives';
          break;
        case '1':
          type = 'videos';
          break;
        case '2':
          type = 'images';
          break;
        // case '12':
        //     type = 'gifs';
        //     break;
        case '16':
          type = 'articles';
          break;
        case '4':
          type = 'files';
          break;
        case '17':
          type = 'cmsknows';
          break;
        case '15':
          type = 'opetrains';
          break;
        case '13':
          type = 'aidevices';
          break;
        // case '8':
        //     type = 'packages';
        //     break;
        // case '9':
        //     type = 'zips';
        //     break;
        // case '10':
        //     type = 'others';
        //     break;
        default:
          type = 'texts';
          break;
      }
      return type;
    },
    getDefaultBalueByType (fileType) {
      var val;
      switch (fileType) {
        case '11':
          val = require('../../assets/image/images/default_live_online.jpg');
          break;
        case '1':
          val = require('../../assets/image/images/default_short_video.jpg');
          break;
        case '2':
          val = require('../../assets/image/images/default_hundred_impression.png');
          break;
        // case '12':
        //     val = require('../../assets/image/images/default_dongtu.gif');
        //     break;
        case '16':
          val = require('../../assets/image/images/default_today_news.png');
          break;
        case '4':
          val = require('../../assets/image/images/default_baijia_library.png');
          break;
        case '17':
          val = require('../../assets/image/images/default_cm_knows.png');
          break;
        case '15':
          val = require('../../assets/image/images/default_operation_training.png');
          break;
        case '13':
          val = require('../../assets/image/images/default_ai_equipment.png');
          break;
        // case '8':
        //     val = '';
        //     break;
        // case '9':
        //     val = '';
        //     break;
        // case '10':
        //     val = '';
        //     break;
        default:
          val = ''
      }
      return val;
    },
    initGroupByType (list) {
      const Slist = list.length ? list : [{ standardJson: [] }];
      const tagGrops = Slist.map((stand) => {
        let standItem = {};
        standItem.blockId = stand.blockId;
        standItem.nodeId = stand.nodeId;
        standItem.contentId = stand.contentId;
        standItem.contentRows = stand.contentRows;
        standItem.contentShowFlowPosition = stand.contentShowFlowPosition;
        standItem.contentShowRowsSort = stand.contentShowRowsSort;
        standItem.sceneGroupId = stand.sceneGroupId;
        standItem.sceneId = stand.sceneId;
        standItem.standAllName = '';
        standItem.standList = [];
        standItem.standAllTag = [];

        //设置默认类型数据
        var live = {
          type: 'lives',
          name: '默认直播',
          data: this.getDefaultBalueByType(11)
        };

        var video = {
          type: 'videos',
          name: '默认短视频',
          data: this.getDefaultBalueByType(1)
        };

        var image = {
          type: 'images',
          name: '默认图片',
          data: this.getDefaultBalueByType(2)
        };

        // var gif = {
        //     type:'gifs',
        //     name:'默认动图',
        //     data: this.getDefaultBalueByType(12)
        // };

        var article = {
          type: 'articles',
          name: '默认文字',
          data: this.getDefaultBalueByType(16)
        };

        var file = {
          type: 'files',
          name: '默认文件',
          data: this.getDefaultBalueByType(4)
        };

        var cmsknow = {
          type: 'cmsknows',
          name: '默认知道',
          data: this.getDefaultBalueByType(17)
        };

        var opetrain = {
          type: 'opetrains',
          name: '默认培训',
          data: this.getDefaultBalueByType(15)
        };



        var aidevice = {
          type: 'aidevices',
          name: '默认设备',
          data: this.getDefaultBalueByType(13)
        };

        var texts = {
          type: 'texts',
          name: '默认文字',
          data: this.getDefaultBalueByType(20)
        };



        var tagsAlowList = [];
        var tagsAllEmptys = true;
        stand.standardJson.map((tag) => {
          let typeName = this.getMapNameByType(tag.fileTypeDetail);

          let typeValue = this.getDefaultBalueByType(tag.fileTypeDetail);
          if (typeName == 'lives' && tag.standardData) {
            // if(tag.standardData.indexOf('.jpg')>-1||tag.standardData.indexOf('.png')>-1){
            //     live.data = tag.standardData;
            // }
            live.data = '';
            if (tag.standardData) {
              tagsAllEmptys = false;
              tagsAlowList.push('lives');
            }
          } else if (typeName == 'videos' && tag.standardData) {
            video.data = tag.standardData;
            if (tag.standardData) {
              tagsAllEmptys = false;
              tagsAlowList.push('videos');
            }
          } else if (typeName == 'images' && tag.standardData) {
            image.data = tag.standardData;
            if (tag.standardData) {
              tagsAllEmptys = false;
              tagsAlowList.push('images');
            }
          }
          // else if(typeName=='gifs'&&tag.standardData){
          //     image.data = tag.standardData;
          //     if(tag.standardData){
          //         this.tagsAllEmpty = false;
          //         tagsAlowList.push('gifs');
          //     }
          // }
          else if (typeName == 'articles' && tag.standardData) {
            // article.data = tag.standardData;
            article.data = '';

            if (tag.standardData) {
              tagsAllEmptys = false;
              tagsAlowList.push('articles');
            }
          } else if (typeName == 'files' && tag.standardData) {
            // file.data = tag.standardData;
            file.data = '';

            if (tag.standardData) {
              tagsAllEmptys = false;
              tagsAlowList.push('files');
            }
          } else if (typeName == 'cmsknows' && tag.standardData) {
            // cmsknow.data = tag.standardData;
            cmsknow.data = tag.standardData;

            if (tag.standardData) {
              tagsAllEmptys = false;
              tagsAlowList.push('cmsknows');
            }
          } else if (typeName == 'opetrains' && tag.standardData) {
            // opetrain.data = tag.standardData;
            opetrain.data = '';

            if (tag.standardData) {
              tagsAllEmptys = false;
              tagsAlowList.push('opetrains');
            }
          } else if (typeName == 'aidevices' && tag.standardData) {
            // aidevice.data = tag.standardData;
            aidevice.data = '';

            if (tag.standardData) {
              tagsAllEmptys = false;
              tagsAlowList.push('aidevices');
            }
          } else if (typeName == 'texts' && tag.standardData) {
            if (tag.standardData) {
              tagsAllEmptys = false;
              tagsAlowList.push('texts');
            }
          }

          if (tag.fileTypeDetail == '' && tag.standardData && standItem.standAllName == '') {
            standItem.standAllName = tag.standardData;
            tagsAllEmptys = false;
          }

          standItem.standAllTag.push({
            name: tag.standardName,
            data: tag.standardData ? tag.standardData : typeValue,
            standardEnName : tag.standardEnName
          })

        })
        // if(!stand.standardJson.length){
        //     this.tagsAllEmpty = true;
        // }
        if (tagsAllEmptys) {
          standItem.standList.push(live);
          standItem.standList.push(video);
          standItem.standList.push(image);
          // standItem.standList.push(text);
          standItem.standList.push(article);
          standItem.standList.push(file);
          standItem.standList.push(cmsknow);
          standItem.standList.push(opetrain);
          standItem.standList.push(aidevice);
          this.tagsAllEmpty = true
        } else {
          if (tagsAlowList.indexOf('lives') > -1) {
            standItem.standList.push(live);
          }
          else if (tagsAlowList.indexOf('videos') > -1) {
            standItem.standList.push(video);
          }
          else if (tagsAlowList.indexOf('images') > -1) {
            standItem.standList.push(image);
          }
          else if (tagsAlowList.indexOf('articles') > -1) {
            standItem.standList.push(article);
          }
          else if (tagsAlowList.indexOf('files') > -1) {
            standItem.standList.push(file);
          }
          else if (tagsAlowList.indexOf('cmsknows') > -1) {
            standItem.standList.push(cmsknow);
          }
          else if (tagsAlowList.indexOf('opetrains') > -1) {
            standItem.standList.push(opetrain);
          }
          else if (tagsAlowList.indexOf('aidevices') > -1) {
            standItem.standList.push(aidevice);
          }
          else if (tagsAlowList.indexOf('texts') > -1) {
            standItem.standList.push(texts);
          }

        }

        return standItem;
      })
      this.tagsDataList = tagGrops;
    },
    swiperFn () {
      let _this = this;
      if (_this.mySwiper1 && _this.mySwiper1[0] !== undefined) {
        _this.mySwiper1[0].destroy();
      }
      let sildeNum = this.preNum;
      if (window.innerWidth > 425 && window.innerWidth <= 768 && (this.centerStyle != 'banner' || this.centerStyle != 'companyIntroduce')) {
        sildeNum = 2;
      }

      if (this.centerStyle == 'banner' || this.centerStyle == 'companyIntroduce') {
        sildeNum = 1;
      }
      this.$nextTick(() => {
        _this.mySwiper1 = new window.Swiper('.bottom-content' + _this.swiperInd, {
          autoplay: false,
          slidesPerView: sildeNum,
          slidesPerGroup: sildeNum,
          spaceBetween: 18,
          navigation: {
            nextEl: '.arrow-right' + this.swiperInd,
            prevEl: '.arrow-left' + this.swiperInd,
          }
        })
      })
    }
  }
}
</script>
<style scoped lang="scss">
.bottom-switch {
  padding: 18px 20px;
  .bottom-content {
    height: 100%;
    overflow: hidden;
    .swiper-slide {
      /* height: 326px !important; */
    }
    .arrow-left {
      z-index: 9;
      display: none;
      width: 22px;
      height: 48px;
      position: absolute;
      top: 50%;
      margin-top: -24px;
      left: 0;
      background: url("~@/assets/images/product_detail/recommend_arrow_left.png")
        no-repeat center;
      cursor: pointer;
    }
    .arrow-right {
      z-index: 9;
      display: none;
      width: 22px;
      height: 48px;
      position: absolute;
      top: 50%;
      margin-top: -24px;
      right: 0;
      background: url("~@/assets/images/product_detail/recommend_arrow_right.png")
        no-repeat center;
      cursor: pointer;
    }
    &:hover {
      .arrow-left {
        display: block;
      }
      .arrow-right {
        display: block;
      }
    }
    ul {
      li {
        display: block;
        font-size: 0;
        margin-right: 18px !important;
        width: 217px;
        height: 260px;
        /* line-height: 108px; */
        background: #fafafa;
        /* border: 1px solid#ddd; */
        position: relative;
        > a {
          display: block;
          width: 100%;
          height: 100%;
          text-align: center;
          position: relative;
          img {
            width: 100%;
            height: 100%;
          }
          .li_hover {
            transition: all 0.2s linear;
            width: calc(100% - 20px);
            // height: 100%;
            position: absolute;
            left: 0;
            bottom: 0px;
            background: rgba(0, 0, 0, 0.6);
            padding: 0 10px;
            // &:hover {
            //     bottom: 0px;
            // }
            .li_hover_title {
              width: 100%;
              margin: 0;
              font-size: 16px;
              color: #fff;
              height: 40px;
              line-height: 40px;
              // border-bottom: 1px dashed #bbbbbb;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              text-align: center;
              // font-weight: 700;
            }
            .img_right {
              color: #ffffff;
              border: 1px solid #ffffff;
              text-align: center;
              line-height: 18px;
              vertical-align: middle;
              border-radius: 50%;
              height: 18px;
              width: 18px;
              position: absolute;
              top: 10px;
              right: 10px;
              &::after {
                position: absolute;
                content: "";
                border-right: 1px solid #ffffff;
                border-top: 1px solid #ffffff;
                transform: rotate(45deg);
                height: 6px;
                width: 6px;
                top: 5px;
                left: 5px;
              }
            }
            .li_hover_conter {
              border-top: 1px dashed #bbbbbb;
              display: none;
              text-align: left;
              font-size: 14px;
              line-height: 20px;
              margin: 10px 0;
              color: #fff;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 7;
              height: calc(100% - 59px);
              width: 198px;
              overflow: auto;
              .label-box {
                width: 100%;
              }
              .label-set {
                height: 26px;
                line-height: 26px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }
            }
            &:hover {
              transition: all 0.2s linear;
              height: 100%;
              .li_hover_conter {
                display: block;
              }
            }
          }
        }
      }
    }
    // 树形菜单
    .watch {
      width: 100%;
      max-height: 100%;
      overflow: hidden;
      line-height: 32px;
      .version {
        font-size: 14px;
        width: 100%;
        word-break: keep-all;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .multistage-left {
        padding-right: 18px;
        width: 282px;
        height: 324px;
        overflow: auto;
      }
      .blue-right {
        padding-left: 18px;
        width: 228px;
        height: 324px;
        overflow: auto;
      }
      .blue-right .version a:hover {
        background-color: #fafafa;
      }
      .blue-right a {
        color: #2f8eed;
        display: block;
        height: 32px;
        width: 100%;
        word-break: keep-all;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .black-center {
        padding: 0 16px;
        border-left: 1px dashed #ddd;
        border-right: 1px dashed #ddd;
        width: calc(100% - 580px);
        height: 324px;
        overflow: auto;
      }
    }
    .no-data {
      color: #999999;
      font-size: 16px;
      text-align: center;
      margin-top: 20px;
    }
    .no-data.white {
      color: #fff;
      font-size: 12px;
      text-align: left;
      margin-top: 0px;
    }
  }
  //企业简介样式
  &.companyIntroduce {
    .bottom-content {
      overflow: hidden auto;
      ul {
        li {
          border: none;
          > a {
            position: relative;
            clear: both;
            width: 100%;
            img {
              float: left;
              width: 50%;
            }
            video {
              float: left;
              width: 50%;
            }
            .z-image {
              float: left;
              width: 50%;
            }
            .linear-gradient {
              float: left;
              width: 50%;
            }
            .li_hover {
              width: calc(50% - 40px);
              background: #fff;
              float: left;
              position: static;
              padding: 0 20px;
              .li_hover_title {
                color: #333333;
              }
              .li_hover_conter {
                color: #333333;
                width: 100%;
              }
            }
          }
        }
      }
    }
  }
  &.banner {
    .bottom-content {
      ul {
        li {
          border: none;
          > a {
            .li_hover {
              display: none;
            }
          }
        }
      }
    }
  }
}

.flow-arch .right-content .bottom-switch .bottom-content ul li {
  height: 260px;
}
/* .flow-arch .right-content .bottom-switch .bottom-content ul li>a .li_hover{
    bottom:-222px;
} */
.flowArchShow
  .right-content
  .bottom-switch
  .bottom-content
  ul
  li
  > a
  .li_hover {
  bottom: 0px;
}
.flow-arch
  .right-content
  .bottom-switch.flowArchShow
  .bottom-content
  ul
  li
  > a
  .li_hover {
  bottom: 0px;
}
.live-main .right-content .bottom-switch.lives-type {
  height: 254px;
}
.live-main .right-content .bottom-switch.lives-type .bottom-content ul li {
  height: 254px;
}
.live-main
  .right-content
  .bottom-switch.lives-type
  .bottom-content
  ul
  li
  > a
  .li_hover {
  bottom: -214px;
}
.live-main
  .right-content
  .bottom-switch.lives-type
  .bottom-content
  ul
  li
  > a
  .li_hover:hover {
  bottom: 0px;
}
</style>
<style lang="scss" scoped>
.bottom-content ul li {
  background-color: #fff !important;
  border: none !important;
}
.right-content .bottom-switch.flowArchShow {
  padding: 0px;
}
.right-content
  .bottom-switch.flowArchShow
  .bottom-content
  ul
  li
  > a
  .li_hover
  .li_hover_conter {
  height: 188px;
}
</style>




// WEBPACK FOOTER //
// src/components/floorBlock/baseGroupProcess.vue